export const compress = async (
  str: string,
  encoding: CompressionFormat = 'gzip',
): Promise<ArrayBuffer> => {
  const byteArray = new TextEncoder().encode(str)
  const cs = new CompressionStream(encoding)
  const writer = cs.writable.getWriter()
  writer.write(byteArray)
  writer.close()
  return new Response(cs.readable).arrayBuffer()
}

export const decompress = async (
  byteArray: BufferSource,
  encoding: CompressionFormat = 'gzip',
): Promise<string> => {
  const cs = new DecompressionStream(encoding)
  const writer = cs.writable.getWriter()
  writer.write(byteArray)
  writer.close()
  const arrayBuffer = await new Response(cs.readable).arrayBuffer()
  return new TextDecoder().decode(arrayBuffer)
}

export const downloadBlob = async (blob: Blob, filename: string) => {
  try {
    if ('showSaveFilePicker' in window && typeof window.showSaveFilePicker === 'function') {
      const fileHandle = await window.showSaveFilePicker({
        suggestedName: filename,
      })
      const writable = await fileHandle.createWritable()
      await writable.write(blob)
      await writable.close()
    }
    else {
      const url = window.URL.createObjectURL(blob)
      const link = document.createElement('a')
      link.href = url
      link.setAttribute('download', filename)
      document.body.appendChild(link)
      link.click()
      link.remove()
    }
  }
  catch (e) {
    console.error('Failed to download blob', e)
  }
}
